export function parseLocalDate(date: string): Date {
  const [y, m, d] = date.split('-').map(p => Number(p));
  return new Date(y, m - 1, d);
}

export const safeDateString = (date: Date | null | undefined): string | null => {
  if (!date || !(date instanceof Date)) return null;
  if (date.toString() === 'Invalid Date') return null;
  return date.toISOString().split('T')[0];
};
